import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
import { ReactComponent as ForkIcon3Long } from "../../assets/icons/Fork3Long.svg";
import { useNavigate } from "react-router-dom";

const PlatformWebData = () => {
  const navigate = useNavigate();

  const block1 = [
    {
      title: "Intelligent Web Links",
      description:
        "Guide users directly to your most relevant pages or campaigns, improving conversion rates and reducing drop-offs.",
      learnMore: () => navigate("/engagement"),
    },

    {
      title: "Automated, Platform-Specific Messaging",
      description:
        "Deliver targeted web messages instantly and automatically to new and returning users without manual intervention.",
      learnMore: () => navigate("/messaging"),
    },

    {
      title: "Comprehensive Attribution",
      description:
        "Accurately track clicks, conversions, and user actions across all web-based campaigns.",
      learnMore: () => navigate("/analyse"),
    },
  ];
  const block2 = [
    {
      title: "Reduce Friction",
      description:
        "Ensure users always find the right content instantly, enhancing their experience and boosting satisfaction.",
      learnMore: () => navigate("/engagement"),
    },

    {
      title: "Optimize Marketing Spend",
      description:
        "Clearly identify the most effective web channels and campaigns for higher conversions.",
      learnMore: () => navigate("/measure"),
    },

    {
      title: "Streamlined Reporting",
      description:
        "Easy-to-use dashboard providing immediate insights into web campaign performance and user interactions.",
      learnMore: () => navigate("/analyse"),
    },
  ];
  return (
    <FullPageContainer>
      <Container>
        <Content>
          <TextWrapper>
            <Title>Web Engagement Tools That Drive Results</Title>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3Long
                color={lightThemeColors.landingPagePrimaryBackground}
              />
            </ForkWrapper>
            <ItemsWrapper>
              {block1.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  learnMore={item.learnMore}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
        <Content>
          <TextWrapper>
            <Title>Turn Web Traffic into Loyal Users</Title>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3Long
                color={lightThemeColors.landingPagePrimaryBackground}
              />
            </ForkWrapper>
            <ItemsWrapper>
              {block2.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  learnMore={item.learnMore}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default PlatformWebData;
const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  gap: 30px;
  max-width: 850px;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;


const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
    gap: 20px;
  overflow: hidden;

`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
display:flex;
align-items:center;
height:100%;
  @media (max-width: 990px) {
    display: none;
  }
`;
